import React from 'react';
import PropTypes from 'prop-types';

// Components
import Post from 'components/post';

// Styles
import styles from './postList.scss';

const PostList = ({
  posts,
}) => (
  <ul className={styles.postList}>
    {posts.map((item) => (
      <li
        className={styles.item}
        key={item.id}
      >
        <Post {...item} />
      </li>
    ))}
  </ul>
);

PostList.propTypes = {
  posts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      link: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      image: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.bool,
      ]).isRequired,
      focusAreas: PropTypes.arrayOf(
        PropTypes.shape({
          link: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        })
      ),
      publicationDate: PropTypes.string.isRequired,
      byline: PropTypes.string.isRequired,
      excerpt: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default PostList;



// WEBPACK FOOTER //
// ./app/components/postList/index.js